import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../api";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(null);
  };

  const completeProfile = async ({ firstName, lastName, newPassword }) => {
    const { data } = await api.post("/auth/profile/complete", {
      firstName,
      lastName,
      newPassword,
    });
    setUser(data.user);
    return data.user;
  };

  const updateProfile = async (patch) => {
    const { data } = await api.patch("/auth/profile", patch);
    setUser(data.user);
    return data.user;
  };

  const changePassword = async ({ currentPassword, newPassword }) => {
    await api.post("/auth/password", { currentPassword, newPassword });
  };

  const adminCreateUser = async ({ email, role }) => {
    const { data } = await api.post("/auth/admin/create-user", { email, role });
    return data.user;
  };

  const adminFetchUsers = async () => {
    const { data } = await api.get("/auth/admin/users");
    return data.users;
  };

  const adminSetRole = async (userId, role) => {
    await api.patch(`/auth/admin/users/${userId}/role`, { role });
  };

  const adminDeleteUser = async (userId) => {
    await api.delete(`/auth/admin/users/${userId}`);
  };

  const fetchJour = async () => {
    const { data } = await api.get("/jour");
    return data.jours;
  };

  const adminAddJour = async (payload) => {
    await api.post("/jour", payload);
  };

  const adminDeleteJour = async (id) => {
    await api.delete(`/jour/${id}`);
  };

  const adminUpdateJour = async (id, payload) => {
    await api.patch(`/jour/${id}`, payload);
  };

  const fetchAssignableUsers = async () => {
    const { data } = await api.get("/users/assignable");
    // normalisera redan här om du vill
    return data.users;
  };

    // Semester-funktioner
  const fetchMyVacations = async () => {
    const { data } = await api.get("/vacations/mine");
    return data.vacations;
  };
  const fetchAllVacations = async () => {
    const { data } = await api.get("/vacations");
    return data.vacations;
  };
  const requestVacation = async (payload) => {
    const { data } = await api.post("/vacations", payload);
    return data.vacation;
  };
  const approveVacation = async (id) => {
    await api.patch(`/vacations/${id}/approve`);
  };
  const suggestVacation = async (id, payload) => {
    await api.patch(`/vacations/${id}/suggest`, payload);
  };
  const acceptVacation = async (id) => {
    await api.patch(`/vacations/${id}/accept`);
  };
  const rejectVacation = async (id) => {
    await api.patch(`/vacations/${id}/reject`);
  };
  const deleteVacation = async (id) => {
    await api.delete(`/vacations/${id}`);
  };



  const value = {
    user,
    loading,
    login,
    logout,
    completeProfile,
    updateProfile,
    changePassword,
    adminCreateUser,
    adminFetchUsers,
    adminSetRole,
    adminDeleteUser,
    fetchJour,
    adminAddJour,
    adminDeleteJour,
    adminUpdateJour,
    fetchMyVacations,
    fetchAllVacations,
    requestVacation,
    approveVacation,
    suggestVacation,
    acceptVacation,
    rejectVacation,
    deleteVacation,
    fetchAssignableUsers,
    refreshUser: fetchMe,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
